import { SortOrder } from '@cp/src/pages/sensei/types';

interface ISortArrowProps {
  sortDirection: SortOrder | null;
}

const SortArrowIcon = (sortInfo: ISortArrowProps) => {
  const { sortDirection = '' } = sortInfo;
  return (
    <div className="_header-wrapper__sort_9n3vu_32">
      <svg width="7" height="7" viewBox="0 0 10 7" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M9.58711 4.01454L5.98011 0.407545C5.43697 -0.135593 4.5596 -0.135593 4.01646 0.407545L0.40946 4.01454C-0.467917 4.89192 0.158781 6.396 1.39825 6.396L8.61224 6.396C9.85171 6.396 10.4645 4.89192 9.58711 4.01454Z"
          fill={
            sortDirection && sortDirection === SortOrder.ASC
              ? 'var(--navi-custom-sort-table-icon-active)'
              : 'var(--navi-custom-sort-table-icon-default)'
          }
        ></path>
      </svg>
      <svg width="7" height="7" viewBox="0 0 10 6" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M0.412893 2.38145L4.01989 5.98845C4.56303 6.53159 5.44041 6.53159 5.98354 5.98845L9.59054 2.38145C10.4679 1.50408 9.84122 0 8.60175 0H1.38776C0.148287 0 -0.464485 1.50408 0.412893 2.38145Z"
          fill={
            sortDirection && sortDirection === SortOrder.DESC
              ? 'var(--navi-custom-sort-table-icon-active)'
              : 'var(--navi-custom-sort-table-icon-default)'
          }
        ></path>
      </svg>
    </div>
  );
};

export default SortArrowIcon;
